import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import PaperDraggable from "../../../../../components/PaperDraggable";
import { FormProvider, useForm } from "react-hook-form";
import Stepper from "./Stepper";
import { formatarMonetárioParaNúmero } from "../../../../../helpers/masks";
import { useMutation } from "react-query";
import axiosClient from "../../../../../lib/axios";
import { enqueueSnackbar } from "notistack";
import moment from "moment";
import { desformatarCPFCNPJ } from "../../../../../helpers/unmask";

export default function DialogIncluirCheques({
    open,
    handleClose
}: DialogIncluirChequesProps) {

    //Querys e mutations
    const { mutate: criarCheque} = useMutation({
        mutationKey: 'incluir-cheque',
        mutationFn: (inputs: any) => axiosClient.post("/financeiro/cheques/incluir-cheque", inputs, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }),
        onError: (error) => {
            console.error(error)
            enqueueSnackbar('Erro ao cadastrar cheque!', { variant: 'error' });
        },
        onSuccess: ({ data }) => {
            enqueueSnackbar(`Cheque criado com sucesso!`, { variant: 'success' });
            handleClose()
        },
        onSettled: () => setValue('isLoadingCheque', false)
    })

    const handleNextStep = () => {
        const stepper = getValues('stepper')
        setValue('stepper', stepper + 1)
    }

    const handleBackStep = () => {
        const stepper = getValues('stepper')
        setValue('stepper', stepper - 1)
    }


    const onSubmit = (data: any) => {
        // setValue('isLoadingCheque', true)

        const params = {
            //STEP01
            tipo_publico: data.step01.publico.tipo_publico,
            codigo_publico: data.step01.publico.codigo_publico,
            cpf_cnpj: desformatarCPFCNPJ(data.step01.documento),
            banco_id: data.step01.banco.codigo,
            agencia: data.step01.agencia,
            agencia_digito: data.step01.agencia_digito,
            conta: data.step01.conta,
            conta_digito: data.step01.conta_digito,
            numero_cheque: data.step01.numero_cheque,
            sequencia_cheque: data.step01.sequencia_cheque,

            
            //STEP02
            departamento_centro_custo_id: data.step02.departamento_centro_custo.id,
            conta_devedora_codigo: data.step02.conta_devedora.codigo_contabil,
            ...(data.step02.conta_devedora.centro_custo && {
                conta_devedora_custo: data.step02.conta_devedora.centro_custo.id,
            }),
            contra_partida_codigo: data.step02.contra_partida.codigo_contabil,
            ...(data.step02.contra_partida.centro_custo && {
                contra_partida_custo: data.step02.contra_partida.centro_custo.id,
            }),
            lote: data.step02.lote,
            data_vencimento: moment(data.step02.data_vencimento).format("YYYY-MM-DD"),
            data_origem: moment(data.step02.data_origem).format("YYYY-MM-DD"),
            valor: formatarMonetárioParaNúmero(data.step02.valor),
            praca: data.step02.praca,
            loja_id: data.step02.loja.id
        }
        criarCheque(params)
    }

    const defaultValuesForm = {
        isLoadingCheque: false,
        stepper: 0,
        step01: {
            publico: '',
            documento: '',
            banco: '',
            agencia: '',
            agencia_digito: '',
            conta: '',
            conta_digito: '',
            numero_cheque: '',
            sequencia_cheque: ''
        },
        step02: {
            lote: '',
            data_vencimento: null,
            valor: '',
            conta_devedora: '',
            contra_partida: '',
            praca: '',
            data_origem: null,
            loja: ''
        },
        funcoesAux: {
            onNext: handleNextStep,
            onBack: handleBackStep,
            onCloseModal: handleClose,
            onSubmit: onSubmit
        },
    }

    const methods = useForm({ defaultValues: defaultValuesForm })
    const { getValues, setValue, } = methods

    return (
        <FormProvider {...methods}>
            <Dialog
                open={open}
                onClose={handleClose}
                maxWidth={'md'}
                fullWidth
                PaperComponent={PaperDraggable}
                aria-labelledby="draggable-dialog-title"
            >
                <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">Incluir cheque</DialogTitle>
                <DialogContent>
                    <Stepper />
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="text"
                        onClick={handleClose}
                    >
                        Fechar
                    </Button>
                </DialogActions>
            </Dialog>
        </FormProvider>
    )
}

export interface DialogIncluirChequesProps {
    open: boolean;
    handleClose: () => void
}
